module.exports = __webpack_public_path__ + "static/media/tusdt-logo.32f12eb3.svg";